import { BASE_CSS_VARS_DARK, BASE_CSS_VARS_LIGHT } from "../base";
import { BUTTONS_BASE_CSS_VARS } from "../base/Buttons";
import { TYPOGRAPHY_BASE_CSS_VARS } from "../base/Typography";

export const DEFAULT_THEME_CSS_VARIABLES = {
  light: {
    "theme-website-color-1": "#FFFFFF",
    "theme-website-color-2": "#F0F3FF",
    "theme-website-color-3": "#D0D2D8",
    "theme-website-color-4": "#071031",
    "theme-website-color-5": "#063CFF",
    "theme-website-color-6": "#0224A0",
    ...BASE_CSS_VARS_LIGHT,
  },
  dark: {
    "theme-website-color-1": "#0F0F1A",
    "theme-website-color-2": "#1A1D2E",
    "theme-website-color-3": "#2F3147",
    "theme-website-color-4": "#E8EAFF",
    "theme-website-color-5": "#869EFD",
    "theme-website-color-6": "#6B85FF",
    ...BASE_CSS_VARS_DARK,
  },
  ...TYPOGRAPHY_BASE_CSS_VARS,
  ...BUTTONS_BASE_CSS_VARS,
};
